<script>
  export let tipoEvaluacion = "teoria";

  import SurveyCombobox from "../../components/SurveyCombobox.svelte";

  import { post } from "../../js/api";
  import { getToken, getUsername } from "../../js/local";

  import { onMount } from "svelte";

  import { navigate } from "svelte-routing";

  const token = getToken();
  const username = getUsername();

  let centros = [];
  let centrosSel = "-1";
  let departamentos = [];
  let departamentosSel = "-1";
  let planes = [];
  let planesSel = "-1";
  let asignaturas = [];
  let asignaturasSel = "-1";
  let profesores = [];
  let profesoresSel = "-1";
  let grupos = [];
  let gruposSel = "-1";

  let errorCentro = false;
  let errorDepartamento = false;
  let errorPlan = false;
  let errorAsignatura = false;
  let errorProfesor = false;
  let errorGrupo = false;

  let centrosLoading = false;
  let departamentosLoading = false;
  let planesLoading = false;
  let asignaturasLoading = false;
  let profesoresLoading = false;
  let gruposLoading = false;

  let centrosLoaded = false;
  let departamentosLoaded = false;
  let planesLoaded = false;
  let asignaturasLoaded = false;
  let profesoresLoaded = false;
  let gruposLoaded = false;

  let encuestaRealizadaFecha = "";

  onMount(() => {
    getCentros();
  });

  let getCentros = async () => {
    encuestaRealizadaFecha = "";

    centrosLoading = true;
    departamentosLoaded = false;
    planesLoaded = false;
    asignaturasLoaded = false;
    profesoresLoaded = false;
    gruposLoaded = false;

    const response = await post("ObtenerCentros", {
      token,
      tipoEvaluacion,
    });
    centros = response.map((item) => {
      return {
        label: item.nombre,
        value: item.codigo,
      };
    });

    centros = centros.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });

    centros.unshift({
      label: "",
      value: "-1",
    });
    centrosSel = centros[0].value;

    departamentos = [];
    departamentosSel = "-1";
    planes = [];
    planesSel = "-1";
    asignaturas = [];
    asignaturasSel = "-1";
    profesores = [];
    profesoresSel = "-1";
    grupos = [];
    gruposSel = "-1";

    centrosLoading = false;
    centrosLoaded = true;

    errorCentro = false;
    errorDepartamento = false;
    errorPlan = false;
    errorAsignatura = false;
    errorProfesor = false;
    errorGrupo = false;
  };

  let getDepartamentos = async () => {
    encuestaRealizadaFecha = "";

    departamentosLoading = true;
    planesLoaded = false;
    asignaturasLoaded = false;
    profesoresLoaded = false;
    gruposLoaded = false;

    if (centrosSel !== "-1") {
      const response = await post("ObtenerDepartamentos", {
        token,
        centro: centrosSel,
        tipoEvaluacion,
      });
      departamentos = response.map((item) => {
        return {
          label: item.nombre,
          value: item.codigo,
        };
      });
      departamentos = departamentos.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      departamentos.unshift({
        label: "",
        value: "-1",
      });
      departamentosSel = departamentos[0].value;

      planes = [];
      planesSel = "-1";
      asignaturas = [];
      asignaturasSel = "-1";
      profesores = [];
      profesoresSel = "-1";
      grupos = [];
      gruposSel = "-1";
    }
    departamentosLoading = false;
    departamentosLoaded = true;

    errorCentro = false;
    errorDepartamento = false;
    errorPlan = false;
    errorAsignatura = false;
    errorProfesor = false;
    errorGrupo = false;
  };

  let getPlanes = async () => {
    encuestaRealizadaFecha = "";

    planesLoading = true;
    asignaturasLoaded = false;
    profesoresLoaded = false;
    gruposLoaded = false;

    //if (departamentosSel !== "-1") {
    const response = await post("ObtenerPlanes", {
      token,
      centro: centrosSel,
      departamento: departamentosSel,
      tipoEvaluacion,
    });
    planes = response.map((item) => {
      return {
        label: item.nombre,
        value: item.codigo,
      };
    });
    planes = planes.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
    planes.unshift({
      label: "",
      value: "-1",
    });
    planesSel = planes[0].value;

    asignaturas = [];
    asignaturasSel = "-1";
    profesores = [];
    profesoresSel = "-1";
    grupos = [];
    gruposSel = "-1";
    //}
    planesLoading = false;
    planesLoaded = true;

    errorCentro = false;
    errorDepartamento = false;
    errorPlan = false;
    errorAsignatura = false;
    errorProfesor = false;
    errorGrupo = false;
  };

  let getAsignaturas = async () => {
    encuestaRealizadaFecha = "";

    asignaturasLoading = true;
    profesoresLoaded = false;
    gruposLoaded = false;

    if (planesSel !== "-1") {
      const response = await post("ObtenerAsignaturas", {
        token,
        centro: centrosSel,
        departamento: departamentosSel,
        plan: planesSel,
        tipoEvaluacion,
      });
      asignaturas = response.map((item) => {
        return {
          label: item.nombre,
          value: item.codigo,
        };
      });
      asignaturas = asignaturas.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      asignaturas.unshift({
        label: "",
        value: "-1",
      });
      asignaturasSel = asignaturas[0].value;

      profesores = [];
      profesoresSel = "-1";
      grupos = [];
      gruposSel = "-1";
    }
    asignaturasLoading = false;
    asignaturasLoaded = true;

    errorCentro = false;
    errorDepartamento = false;
    errorPlan = false;
    errorAsignatura = false;
    errorProfesor = false;
    errorGrupo = false;
  };

  let getProfesores = async () => {
    encuestaRealizadaFecha = "";

    profesoresLoading = true;
    gruposLoaded = false;

    if (asignaturasSel !== "-1") {
      const response = await post("ObtenerProfesores", {
        token,
        centro: centrosSel,
        departamento: departamentosSel,
        plan: planesSel,
        asignatura: asignaturasSel,
        tipoEvaluacion,
      });
      profesores = response.map((item) => {
        return {
          label: item.nombre,
          value: item.DNI,
        };
      });
      profesores = profesores.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      profesores.unshift({
        label: "",
        value: "-1",
      });
      profesoresSel = profesores[0].value;

      grupos = [];
      gruposSel = "-1";
    }
    profesoresLoading = false;
    profesoresLoaded = true;

    errorCentro = false;
    errorDepartamento = false;
    errorPlan = false;
    errorAsignatura = false;
    errorProfesor = false;
    errorGrupo = false;
  };

  let getGrupos = async () => {
    encuestaRealizadaFecha = "";

    gruposLoading = true;
    if (profesoresSel !== "-1") {
      const response = await post("ObtenerGrupos", {
        token,
        centro: centrosSel,
        departamento: departamentosSel,
        plan: planesSel,
        asignatura: asignaturasSel,
        profesor: profesoresSel,
        tipoEvaluacion,
      });
      grupos = response.map((item) => {
        return {
          label: item.nombre,
          value: item.codigo,
        };
      });
      grupos = grupos.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      grupos.unshift({
        label: "",
        value: "-1",
      });
      gruposSel = grupos[0].value;
    }
    gruposLoading = false;
    gruposLoaded = true;

    errorCentro = false;
    errorDepartamento = false;
    errorPlan = false;
    errorAsignatura = false;
    errorProfesor = false;
    errorGrupo = false;
  };

  let iniciarEvaluacion = async () => {
    errorCentro = centrosSel === "-1";
    //errorDepartamento = departamentosSel === "-1";
    errorPlan = planesSel === "-1";
    errorAsignatura = asignaturasSel === "-1";
    errorProfesor = profesoresSel === "-1";
    errorGrupo = gruposSel === "-1";
    if (
      !errorCentro &&
      //!errorDepartamento &&
      !errorPlan &&
      !errorAsignatura &&
      !errorProfesor &&
      !errorGrupo
    ) {
      const centro = centros.find((item) => {
        return item.value === centrosSel;
      });
      /*const departamento = departamentos.find((item) => {
        return item.value === departamentosSel;
      });*/
      const plan = planes.find((item) => {
        return item.value === planesSel;
      });
      const asignatura = asignaturas.find((item) => {
        return item.value === asignaturasSel;
      });
      const profesor = profesores.find((item) => {
        return item.value === profesoresSel;
      });
      const grupo = grupos.find((item) => {
        return item.value === gruposSel;
      });
      const response = await post("IniciarEvaluacion", {
        token,
        centro: centro.label,
        centroCod: centrosSel,
        //departamento: departamento.label,
        //departamentoCod: departamentosSel,
        plan: plan.label,
        planCod: planesSel,
        asignatura: asignatura.label,
        asignaturaCod: asignaturasSel,
        profesor: profesor.label,
        profesorCod: profesoresSel,
        grupo: grupo.label,
        grupoCod: gruposSel,
        responsableUsername: username,
        tipoEvaluacion,
      });
      //console.log(response);

      navigate("/evaluador/" + tipoEvaluacion + "/" + response.idInterno, {
        replace: true,
      });
    }
  };

  let comprobarEncuesta = async () => {
    encuestaRealizadaFecha = "";
    const response = await post("ComprobarEvaluacion", {
      token,
      centroCod: centrosSel,
      departamentoCod: departamentosSel,
      planCod: planesSel,
      asignaturaCod: asignaturasSel,
      profesorCod: profesoresSel,
      grupoCod: gruposSel,
      tipoEvaluacion,
    });
    if (response.fechaCierre) {
      encuestaRealizadaFecha = moment(
        response.fechaCierre,
        "YYYY-MM-DD HH:mm:ss"
      ).format("DD/MM/YYYY HH:mm:ss");
    }
  };
</script>

<div class="screen">
  <div class="screenheader">
    <div class="headertitle">
      <div class="headersteptxt nomargin">1</div>
      <div class="headertitletxt">
        <strong class="textbold">Cumplimente </strong>este cuestionario
      </div>
    </div>
    <img
      src="/images/logo-uex-white.png"
      loading="lazy"
      width="80"
      sizes="(max-width: 479px) 60px, (max-width: 767px) 55px, (max-width: 991px) 65px, 80px"
      srcset="/images/logo-uex-white-p-500.png 500w, /images/logo-uex-white.png 780w"
      alt=""
      class="logoheader"
    />
  </div>
  <div class="screenbody">
    <div class="centercontent">
      <!--<SurveyCombobox
        title="Centro"
        options={centros}
        bind:selectedOption={centrosSel}
        code={centrosSel}
        onChange={() => getDepartamentos()}
        error={errorCentro}
        loading={centrosLoading}
        loaded={centrosLoaded}
      />
      <SurveyCombobox
        title="Departamento"
        options={departamentos}
        bind:selectedOption={departamentosSel}
        code={departamentosSel}
        onChange={() => getPlanes()}
        error={errorDepartamento}
        loading={departamentosLoading}
        loaded={departamentosLoaded}
      />-->
      <SurveyCombobox
        title="Centro"
        options={centros}
        bind:selectedOption={centrosSel}
        code={centrosSel}
        onChange={() => getPlanes()}
        error={errorCentro}
        loading={centrosLoading}
        loaded={centrosLoaded}
      />
      <SurveyCombobox
        title="Plan de Estudios"
        options={planes}
        bind:selectedOption={planesSel}
        code={planesSel}
        onChange={() => getAsignaturas()}
        error={errorPlan}
        loading={planesLoading}
        loaded={planesLoaded}
      />
      <SurveyCombobox
        title="Asignatura"
        options={asignaturas}
        bind:selectedOption={asignaturasSel}
        code={asignaturasSel}
        onChange={() => getProfesores()}
        error={errorAsignatura}
        loading={asignaturasLoading}
        loaded={asignaturasLoaded}
      />
      <SurveyCombobox
        title="Profesor"
        options={profesores}
        bind:selectedOption={profesoresSel}
        code=""
        onChange={() => getGrupos()}
        error={errorProfesor}
        loading={profesoresLoading}
        loaded={profesoresLoaded}
      />
      <SurveyCombobox
        title="Grupo"
        options={grupos}
        bind:selectedOption={gruposSel}
        code={gruposSel}
        onChange={() => comprobarEncuesta()}
        error={errorGrupo}
        loading={gruposLoading}
        loaded={gruposLoaded}
      />

      {#if encuestaRealizadaFecha !== ""}
        <div class="encuestaRealizada">
          <span
            ><b>ATENCIÓN:</b> Esta encuesta ya ha sido realizada con fecha {encuestaRealizadaFecha}.</span
          >
        </div>
      {/if}

      {#if centrosLoaded /*&& departamentosLoaded*/ && planesLoaded && asignaturasLoaded && profesoresLoaded && gruposLoaded}
        <div
          class="greenbuttonstyle w-button"
          on:click={() => iniciarEvaluacion()}
        >
          Iniciar cuestionario
        </div>
      {/if}
    </div>
  </div>
  <div class="screenfooter">
    <img
      src="/images/logo-uex-complete-black.png"
      loading="lazy"
      width="300"
      sizes="(max-width: 479px) 83vw, 250px"
      srcset="/images/logo-uex-complete-black-p-500.png 500w, /images/logo-uex-complete-black-p-800.png 800w, /images/logo-uex-complete-black-p-1080.png 1080w, /images/logo-uex-complete-black-p-1600.png 1600w, /images/logo-uex-complete-black-p-2000.png 2000w, /images/logo-uex-complete-black-p-2600.png 2600w, /images/logo-uex-complete-black-p-3200.png 3200w, /images/logo-uex-complete-black.png 3994w"
      alt=""
      class="logobottom"
    />
  </div>
</div>

<style>
  div.encuestaRealizada {
    margin-bottom: 40px;
  }

  div.encuestaRealizada span {
    color: #c10000;
    font-size: 18px;
  }
</style>
